'use client'

import { Button } from '@pw-tech/omni-ui'
import React from 'react'
import styles from './styles.module.css'

const GetStartedButton = ({
  handleOpenBookDemoModal,
  title,
}: {
  handleOpenBookDemoModal: ({ clickFrom }: { clickFrom: string }) => void
  title?: string
}) => {
  return (
    <Button
      size='large'
      className={styles.button}
      onClick={() => handleOpenBookDemoModal({ clickFrom: 'hands_on_learning_section' })}
      id='get-started-demo-book-button'
    >
      {title || 'Get Started'}
    </Button>
  )
}

export default React.memo(GetStartedButton)
